import {
  FormControl,
  InputAdornment,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from '@mui/material'
import React, { useState } from 'react'
import { BsSearch } from 'react-icons/bs'
import { documents } from 'data/DocumentLibraryData'
import dayjs, { Dayjs } from 'dayjs'
import { InputGroupField, SelectField } from 'cwp-components/forms/InputFields'
import { DateRangePicker } from 'cwp-components/forms/DateRangePicker'

const defaultFilters = {
  search: '',
  type: '',
  date_from: '2025/1/31',
  date_to: '',
}

const FilteringPane = () => {
  const [state, setState] = useState(1)
  const [filters, setFilters] = useState(defaultFilters)
  const [value, setValue] = React.useState<Dayjs | null>(dayjs('2022-04-17'))

  const handleFilterTab = (selected: any) => {
    setState(selected)
  }

  const handleInputOnChange = (e: any) => {
    setFilters((prev) => ({ ...prev, [e.target.name]: e.target.value }))
  }

  return (
    <div className='flex justify-between items-center flex-wrap'>
      <div className='flex md:gap-[10px] h-[40px] shadow-[#BBD2D7_1px_1px_1px_0px_inset,#F4F4F4_1px_1px_2px_0px_inset]  bg-[rgba(237,237,237,0.15)] p-[6px] text-[16px] text-[#37A2BA] max-sm:mb-[20px]'>
        <button
          onClick={() => handleFilterTab(1)}
          className={`${
            state === 1 &&
            'hover:text-[#fff] hover:bg-[#0C5F71]  hover:shadow-[0.5px_0.5px_0.5px_0px_rgba(0,0,0,0.25)] '
          } h-[34.759px] p-[0px_10px] rounded-[5px]`}
        >
          View all
        </button>
        <button
          onClick={() => handleFilterTab(2)}
          className={`${
            state === 2 &&
            'hover:text-[#fff] hover:bg-[#0C5F71]  hover:shadow-[0.5px_0.5px_0.5px_0px_rgba(0,0,0,0.25)] '
          } h-[34.759px] p-[0px_10px] rounded-[5px]`}
        >
          Your files
        </button>
        <button
          onClick={() => handleFilterTab(3)}
          className={`${
            state === 3 &&
            'hover:text-[#fff] hover:bg-[#0C5F71]  hover:shadow-[0.5px_0.5px_0.5px_0px_rgba(0,0,0,0.25)] '
          } h-[34.759px] p-[0px_10px] rounded-[5px]`}
        >
          Shared files
        </button>
      </div>
      <div className='flex flex-wrap md:gap-[49px] gap-[10px] items-end'>
        <InputGroupField
          label=''
          className='md:w-[320px] max-sm:w-full h-[52px]'
          placeholder='Search'
          Icon={BsSearch}
          reverse
        />

        <SelectField
          records={[]}
          name=''
          id=''
          className='md:w-[196px] max-sm:w-full h-[52px]'
        />

        <div>
          <p>Purchase date</p>
          <DateRangePicker />
        </div>
      </div>
      {/* <div className='mt-5 flex justify-end gap-5 action'>
        <button>Apply filters</button>
        <button>Clear</button>
      </div> */}
    </div>
  )
}

export default FilteringPane
